import { generatePdf } from '../helper/legalInfoHelper';
import { CREDIT_CARD } from 'constants/userProfile';
import { getPdfByPartnerId } from 'constants/creditCard/partners';
import { PRECONTRACTUAL_INFORMATION_DOCUMENT } from '../constants';

export const useProducts = ({ products, investmentType }) => {
    const productsInfo = products.get('products');

    const getPartnerId = () => products?.get('partner')?.get('id');

    const urlsPdfs = () => productsInfo.map(value => value.url) ?? [];

    const precontractualLinks =
        investmentType === CREDIT_CARD
            ? [getPdfByPartnerId(getPartnerId()), PRECONTRACTUAL_INFORMATION_DOCUMENT]
            : generatePdf(urlsPdfs());

    return {
        precontractualLinks,
        productsInfo,
        getPartnerId,
    };
};
